import CircularProgress from '@eversports/react-components/primitives/CircularProgress'
import Flex from '@eversports/react-components/primitives/Flex'
import { makeStyles } from '@mui/styles'
import React from 'react'

const useStyles = makeStyles({
  fullHeight: {
    height: '100%',
  },
})

const LoadingPage: React.FC<React.PropsWithChildren<unknown>> = () => {
  const classes = useStyles()

  return (
    <Flex justifyContent="center" alignItems="center" className={classes.fullHeight}>
      <CircularProgress />
    </Flex>
  )
}

export default LoadingPage
